import {bindGigyaToggleContent, bindInfoSubscription, setCustomData} from '.'
import {BRAND_KEY} from '../../brand'
import {searchCustomerByEmail} from '../../custom-hooks/use-gigya-ssr'

//const CONTAINER_ID = 'js-dlg-gigya-newsletter-container'

export default class GigyaBasicFormController {
    static isTrue = (value) => value === true || value === 'true'

    static getCustomerId = (siteId) => {
        const onClient = typeof window !== 'undefined'
        if (onClient) {
            return localStorage.getItem(`customer_id_${siteId}`)
        }
        return null
    }

    static getAccessToken = (siteId) => {
        const onClient = typeof window !== 'undefined'
        if (onClient) {
            return localStorage.getItem(`access_token_${siteId}`)
        }
        return null
    }

    static onAfterScreenLoad(event) {
        //GigyaController.onAfterScreenLoad(event)
        bindGigyaToggleContent(event.sourceContainerID, '#gigya-subscribe-with-email-form')
        bindInfoSubscription(event.sourceContainerID, '#gigya-subscribe-with-email-form')
        //const gigyaTextbox = document.getElementById('gigya-textbox-email')
        /* if (DLG.config.isLogged) {
            gigyaTextbox.disabled = true
        } */
    }

    static async onBeforeValidation({formData}, message, siteId) {
        const email = formData['profile.email']
        const token = this.getAccessToken(siteId)
        const customerId = this.getCustomerId(siteId)
        const data = await searchCustomerByEmail(email, token, customerId)
        const errors = [
            {
                'profile.email': message,
            },
        ]
        // console.debug(data)
        if (data.totalCount !== 0) {
            //notifyError(data.message)
            //setLabelErrorClass(CONTAINER_GUEST_ID, 'profile.email', false)
            return errors[0]
        }
    }

    static onBeforeSubmit = (
        event,
        selector = '.gigya-input-checkbox.fd-checkbox',
        newsletter = false,
    ) => {
        const selectorDE = '.gigya-input-checkbox.subscription-checkbox'
        const {sourceContainerID} = event
        // get the locale
        const lang = window.gigya.thisScript.lang.originalLang
        // get the country code
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
        const container = document.getElementById(sourceContainerID)
        const checkbox = container?.querySelector(countryCode === 'DE' ? selectorDE : selector)
        const consent = container?.dataset.consentMandatory

        const isConsentRequired = GigyaBasicFormController.isTrue(consent) || consent === null
        const isCheckboxChecked = checkbox?.checked === true

        if ((newsletter && !isCheckboxChecked) || (isConsentRequired && !isCheckboxChecked)) {
            return false
        }

        return true
    }

    static onSubmit = (event, origin = null, selector, hmc, campaignTag) => {
        setCustomData(event, origin, hmc, campaignTag)
        const selectorDE = '.gigya-input-checkbox.subscription-checkbox'
        // get the locale
        const lang = window.gigya.thisScript.lang.originalLang
        // get the country code
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]
        event.formModel.preferences = {}
        event.formModel.preferences = GigyaBasicFormController.marketing(
            event,
            countryCode,
            countryCode === 'DE' ? selectorDE : selector,
        )
    }

    static marketing = (event, countryCode, selector = null) => {
        const {sourceContainerID} = event

        // get the consent field related to the country code
        const siteConsent = window.gigya.thisScript.globalConf.consentMapping[countryCode]

        const mandatoryConsent = document.getElementById(sourceContainerID) || document
        const querySelectorCheckbox = selector || '.gigya-input-checkbox.fd-checkbox'
        const customCheckbox =
            mandatoryConsent.querySelector(querySelectorCheckbox) ||
            mandatoryConsent.querySelector('.gigya-input-checkbox.fd-checkbox')

        //if (!customCheckbox.checked) return {}

        const cleanCountryCode = countryCode ? countryCode.split(/[_-]/).pop() : countryCode
        const isCG = {
            isConsentGranted: !!customCheckbox?.checked,
            entitlements: customCheckbox?.checked ? [`${BRAND_KEY}${cleanCountryCode}`] : [],
        }

        return {[siteConsent]: isCG}
    }

    static onBeforeScreenLoad() {
        const newsletterBtn = document.getElementById('js-show-newsletter-popup')
        newsletterBtn.addEventListener('click', () => {
            let interval
            let intervalC = 0
            const intervalM = 30
            ;(() => {
                interval = setInterval(() => {
                    const form = document.getElementById('gigya-subscribe-with-email-form')
                    if (intervalC > intervalM) {
                        clearInterval(interval)
                    } else if (form !== null) {
                        clearInterval(interval)
                        const inputName = form.querySelectorAll('[name = "profile.firstName"]')
                        const inputSurname = form.querySelectorAll('[name = "profile.lastName"]')
                        inputName[0].setAttribute('maxlength', '40')
                        inputSurname[0].setAttribute('maxlength', '40')
                    }
                    intervalC += 1
                }, 1000)
            })()
        })
    }

    static onAfterSubmit = async (e, ssrGigyaMethods, selector, openModalDOI = true) => {
        const {getLiteToken, getAccountInfo, setAccountInfo, resendDOIConfirmationEmail} =
            ssrGigyaMethods
        const selectorDE = '.gigya-input-checkbox.subscription-checkbox'

        const response = await getLiteToken(e.profile.email)
        const completeProfile = await getAccountInfo(null, response.token)

        // get the locale
        const lang = window.gigya.thisScript.lang.originalLang
        // get the country code
        const countryCode = window.gigya.thisScript.globalConf.countryCodeMapping[lang]

        const parameters = {
            regToken: response.token,
            preferences: GigyaBasicFormController.marketing(
                e,
                countryCode,
                countryCode === 'DE' ? selectorDE : selector,
            ),
        }

        if (countryCode === 'DE') {
            if (
                completeProfile?.subscriptions?.newsDlDE?.email?.isSubscribed &&
                completeProfile?.subscriptions?.newsDlDE?.email?.doubleOptIn?.status !== 'Confirmed'
            ) {
                resendDOIConfirmationEmail({
                    email: e.profile.email,
                    lang: window.gigya.thisScript.lang.originalLang,
                    subscriptionId: 'newsDlDE',
                })

                if (openModalDOI) {
                    setTimeout(() => {
                        window.DOI.EVE.emit('EVENTS.GIGYA.DOI.MODAL')
                    }, 1000)
                }
            } else if (!completeProfile?.subscriptions?.newsDlDE?.email?.isSubscribed) {
                parameters.subscriptions = {
                    newsDlDE: {
                        email: {
                            isSubscribed: true,
                        },
                    },
                }

                if (openModalDOI) {
                    setTimeout(() => {
                        window.DOI.EVE.emit('EVENTS.GIGYA.DOI.MODAL')
                    }, 1000)
                }
            }
        }
        console.debug('set-account-info')
        setAccountInfo(parameters)

        return completeProfile
    }
}
